import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import './FeedbackCarousel.css';

const feedbacks = [
  {
    name: 'Alice Smith',
    rating: 5,
    message: 'Excellent service and support throughout our project!',
  },
  {
    name: 'George Brown',
    rating: 4,
    message: 'Professional and always available when needed.',
  },
  {
    name: 'Emily Johnson',
    rating: 5,
    message: 'They treat you like a real partner, not just a client.',
  },
  {
    name: 'Michael Lee',
    rating: 5,
    message: 'Great communication and very skilled team.',
  },
  {
    name: 'Sophia Patel',
    rating: 4,
    message: 'Solid delivery and impressive quality of work.',
  },
];

const StarRating = ({ rating }) => (
  <div className="stars">
    {[...Array(5)].map((_, i) => (
      <span key={i} className={i < rating ? 'filled-star' : 'empty-star'}>★</span>
    ))}
  </div>
);

const FeedbackCarousel = () => {
  return (
    <div className="client-feedback-section mt-2">
      <h3 className="text-center mb-4">What Our Clients Say</h3>
      <Swiper
        modules={[Autoplay, Pagination]}
        autoplay={{ delay: 3000 }}
        loop={true}
        pagination={{ clickable: true }}
        spaceBetween={30}
        slidesPerView={1}
        breakpoints={{
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
      >
        {feedbacks.map((fb, idx) => (
          <SwiperSlide key={idx}>
            <div className="feedback-card p-4 shadow rounded">
              <h5>{fb.name}</h5>
              <StarRating rating={fb.rating} />
              <p className="mt-2">{fb.message}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default FeedbackCarousel;
